import { useState } from "react";
import type { OrganisationInfo } from "@components/accountConfiguration/AccountConfig.types";
import { BaseService } from "@services/BaseService";
import environment from "environment";
import type { OrganisationInfoResponseV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers";
import { unescapeObjectValues } from "@ucchub/ui";
import { t } from "i18next";

const KEYS_TO_BE_UNESCAPED: (keyof OrganisationInfo)[] = [
  "accountManagerEmail",
  "commercialManagerEmail",
  "commercialId",
  "voicePlatformId",
  "messagingPlatformId",
];

const useAccountConfig = () => {
  const [organisationInfo, setOrganisationInfo] = useState<OrganisationInfo>();
  const [error, setError] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const fetchAccountConfig = (orgId: string) => {
    setIsLoading(true);
    setError("");
    const apiUrl = environment.api.organisationInfo + `/${orgId}`;

    BaseService.get<OrganisationInfoResponseV1>(apiUrl)
      .then(({ data }) => {
        setOrganisationInfo(unescapeObjectValues(data, KEYS_TO_BE_UNESCAPED));
      })
      .catch(() => {
        setError(t("core:accountConfig:fetch_failure") || undefined);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    organisationInfo,
    error,
    isLoading,
    fetchAccountConfig,
  };
};

export default useAccountConfig;
